import {
  CalendarItemUnion,
  CalendarItemUnionUpdate,
} from '@akin-home/calendar/combined';
import { pickAttributes } from '@akin-home/objects';
import { useCallback } from 'react';
import { useUpdateFieldsCommand } from '../../chat/hooks';

export const useUpdateCalendarItemFormListener = (
  onUpdate: (item: Partial<CalendarItemUnion>) => void
) => {
  useUpdateFieldsCommand(
    useCallback(
      (data: any) => {
        const item: CalendarItemUnionUpdate = pickAttributes(data, [
          'title',
          'emoji',
          'notes',
          'color',
          'start_date',
          'start_time',
          'end_date',
          'end_time',
        ]);

        onUpdate(item);
      },
      [onUpdate]
    )
  );
};
